import styled from 'styled-components'
import { themeStyles, themeMedia } from '../../../styles/theme'

export const StyledGameDescriptionWrapper = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2em;
  background-color: ${themeStyles.colors.black.main};
  color: ${themeStyles.colors.white.main};
  text-align: center;

  padding: 1em 0 2em;
  ${themeMedia.maxMobile`
    gap: 1.4em;

    > button, > a {
      max-width: 95%;
    }
  `}
  > a {
    order: 1;
  }
`

export const StyledImageWrapper = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: column;
  order: 0;
  height: 300px;
  min-width: 225px;

  ${themeMedia.tablet`
    height: 454px; 
  `}

  picture, picture > img {
    height: 100%;
    border-radius: 8px;
    max-width: calc(100% + 16px);
    object-fit: cover;
  }

  img:nth-child(2) {
    position: absolute;
    width: 25px;
    height: 25px;
    bottom: -20px;
    right: -20px;
    padding: 25px;
    background: radial-gradient(rgba(0, 0, 0, 0.5) 15%, transparent 40%);
    ${themeMedia.tablet`
      width: 35px;
      height: 35px;
      bottom: -16px;
      right: -16px;
    `}
  }
`

export const StyledPlayForFunButton = styled.button`
  order: 2;
  display: flex;
  align-items: center;
  background-color: transparent;
  color: ${themeStyles.colors.white.main};
  text-decoration: underline;
  height: 2.4em;
`

export const StyledTextWrapper = styled.div`
  order: 2;
  max-width: 80%;
  > * {
    text-align: center;
    margin: 0;
  }
`
